import { render, staticRenderFns } from "./details_effectues.vue?vue&type=template&id=24fa5fca"
import script from "./details_effectues.vue?vue&type=script&lang=js"
export * from "./details_effectues.vue?vue&type=script&lang=js"
import style0 from "./details_effectues.vue?vue&type=style&index=0&id=24fa5fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports